import {
  CheckStageSettingsInputChecksInner,
  CustomPromptCheckSettingsTypeEnum,
  ExternalCheckSettingsInputTypeEnum,
  ExternalMaskingDetectorSettingsInputTypeEnum,
  MaskingSettingsInputDetectorsInner,
  RegexCheckSettingsTypeEnum,
  RegexMaskingDetectorSettingsTypeEnum,
} from '../../../../../gamma-api';

export enum GuardrailStageKey {
  Input = 'input',
  Output = 'output',
}

export const CheckTypeValue = {
  CustomPromptCheck: CustomPromptCheckSettingsTypeEnum.CustomPromptCheck,
  ExternalCheck: ExternalCheckSettingsInputTypeEnum.ExternalCheck,
  RegexCheck: RegexCheckSettingsTypeEnum.RegexCheck,
} as const;

export type CheckTypeValue = typeof CheckTypeValue[keyof typeof CheckTypeValue];

export const MaskingDetectorTypeValue = {
  External: ExternalMaskingDetectorSettingsInputTypeEnum.External,
  Regex: RegexMaskingDetectorSettingsTypeEnum.Regex,
} as const;

export type MaskingDetectorTypeValue = typeof MaskingDetectorTypeValue[keyof typeof MaskingDetectorTypeValue];

export type GuardrailCheckSettings = CheckStageSettingsInputChecksInner;
export type GuardrailDetectorSettings = MaskingSettingsInputDetectorsInner;

export interface ICheckStep {
  key: string;
  check: GuardrailCheckSettings;
}

export interface IMaskingDetectorStep {
  key: string;
  detector: GuardrailDetectorSettings;
}

export interface IGuardrailSummaryLineItem {
  kind: 'line';
  label: string;
  value: string;
}

export interface IGuardrailSummaryPromptItem {
  kind: 'prompt';
  label: string;
  value: string;
  configured: boolean;
}

export type IGuardrailSummaryItem = IGuardrailSummaryLineItem | IGuardrailSummaryPromptItem;
